import React from 'react';

import styles from './dualEntityDisplayStyles';

import PanelWithHeading from 'buyside/components/presentation/Feed/CorporateAction/PanelWithHeading/panelWithHeading';
import RecentIdeaList from 'buyside/components/presentation/Feed/CorporateAction/RecentIdeaList/recentIdeaList';

const DualEntityDisplay = ({
  parentEntity,
  parentAsset,
  childEntity,
  childAsset,
  actionType,
  parentPreActionPrice,
  parentPostActionPrice,
  parentActionPeriodReturn,
  childPreActionPrice,
  childPostActionPrice,
  childActionPeriodReturn,
  timeframe,
  currentUser
}) => {
  const firstTitle = actionType === 'acquisition' ? 'Acquirer' : 'Parent';
  const secondTitle = actionType === 'acquisition' ? 'Acquiree' : 'Spin-off';

  const parentRecentIdeas = parentAsset ? parentAsset.recentIdeas : parentEntity.recentIdeas;
  const childRecentIdeas = childAsset ? childAsset.recentIdeas : childEntity.recentIdeas;

  return (
    <div>
      <div className={styles.contentWrap}>
        <PanelWithHeading
          title={firstTitle}
          entity={parentEntity}
          asset={parentAsset}
          preActionPrice={parentPreActionPrice}
          postActionPrice={parentPostActionPrice}
          actionPeriodReturn={parentActionPeriodReturn}
          timeframe={timeframe}
        />
        <PanelWithHeading
          title={secondTitle}
          entity={childEntity}
          asset={childAsset}
          preActionPrice={childPreActionPrice}
          postActionPrice={childPostActionPrice}
          actionPeriodReturn={childActionPeriodReturn}
          timeframe={timeframe}
        />
      </div>
      <div className={styles.contentWrap}>
        <RecentIdeaList ideas={parentRecentIdeas} currentUser={currentUser} limit={3} />
        <RecentIdeaList ideas={childRecentIdeas} currentUser={currentUser} limit={3} />
      </div>
    </div>
  );
};

export default DualEntityDisplay;
